import { observer } from 'mobx-react-lite';
import findReadWriteRecipient from '../actions/findReadWriteRecipient';
import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { getRTL } from '@fluentui/react/lib/Utilities';
import FindRecipient from 'owa-recipient-common/lib/components/FindRecipient';
import { DirectorySearchType } from 'owa-recipient-types/lib/types/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import * as React from 'react';
import {
    AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX,
    AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL,
} from '../constants';
import FindRecipientInfo, {
    FindRecipientInfoType,
} from 'owa-recipient-common/lib/components/FindRecipientInfo';
import { PluginUIProps } from 'owa-editor/lib/store/schema/PluginWithUI';
import AtMentionPickerPlugin from '../plugin/AtMentionPickerPlugin';

const styles = require('./AtMentionsResult.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function AtMentionsResult(
    props: PluginUIProps<AtMentionsViewState, AtMentionPickerPlugin>
) {
    const searchDirectoryAction = () => {
        findReadWriteRecipient(
            props.viewState,
            props.viewState.queryString,
            true /* searchDirectory */
        );
    };
    const addRecipientAction = (recipientToAdd: FindRecipientPersonaType) => {
        props.plugin.dataProvider.addRecipient(recipientToAdd);
    };
    const getInfoElementType = (viewState: AtMentionsViewState): FindRecipientInfoType => {
        const hasQueryString = !!viewState.queryString;
        if (viewState.isSearching) {
            return FindRecipientInfoType.Searching;
        } else if (!hasQueryString && viewState.findResultSet.length == 0) {
            return FindRecipientInfoType.TypeToSearch;
        } else if (hasQueryString) {
            if (viewState.directorySearchType == DirectorySearchType.None) {
                return FindRecipientInfoType.SearchDirectory;
            } else {
                return FindRecipientInfoType.TopNResults;
            }
        }
        return FindRecipientInfoType.Default;
    };
    const { viewState } = props;
    const { targetPoint, bufferZone } = viewState;
    return targetPoint ? (
        <Callout
            className={styles.callout}
            gapSpace={bufferZone}
            target={targetPoint}
            isBeakVisible={false}
            setInitialFocus={false}
            directionalHint={
                getRTL() ? DirectionalHint.bottomRightEdge : DirectionalHint.bottomLeftEdge
            }>
            {viewState.findResultSet.length != 0 && (
                <div className={classNames(styles.scrollContainer, 'customScrollBar')}>
                    <div
                        id={AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX}
                        className={styles.recipientCollection}
                        role="list">
                        {viewState.findResultSet.map((result, index) => (
                            <div
                                key={result.EmailAddress.EmailAddress}
                                id={AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL + index.toString()}
                                role="listitem">
                                <FindRecipient
                                    findRecipient={result}
                                    isHighlighted={viewState.selectedRecipientIndex == index}
                                    addRecipientAction={addRecipientAction}
                                    maskRecipientAction={null}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <FindRecipientInfo
                infoType={getInfoElementType(viewState)}
                queryString={viewState.queryString}
                highlighted={viewState.findResultSet.length == viewState.selectedRecipientIndex}
                numberOfResults={viewState.findResultSet.length}
                searchDirectoryAction={searchDirectoryAction}
            />
        </Callout>
    ) : null;
});
